import { render, staticRenderFns } from "./TabGraficoDaReceita.vue?vue&type=template&id=4363fdec&scoped=true&"
import script from "./TabGraficoDaReceita.vue?vue&type=script&lang=js&"
export * from "./TabGraficoDaReceita.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoDaReceita.vue?vue&type=style&index=0&id=4363fdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363fdec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTab,VTabItem,VTabs})
